import React from 'react';

export type Orientation = 'landscape' | 'portrait';
type IPdfContext = {
    orientation: Orientation;
    pageStartingNumber?: number;
};
const defaultContext: IPdfContext = {
    orientation: 'portrait',
};

const ExportPdfContext = React.createContext<IPdfContext>(defaultContext);

export default ExportPdfContext;
